export default __webpack_public_path__ + "static/media/bedIconBlack.a5609002.svg";